// import { storage } from './firebase'
import { useState } from 'react'
// import { makeThumbnailPath } from './common'

import CircularProgress from '@mui/material/CircularProgress'

const PhotoItem = ({path, onClick}) => {
  // const [image, setImage] = useState(path)
  const [loaded, setLoaded] = useState(false)

  const size = 90

  // const thumbPath = makeThumbnailPath(path)

  // console.log('PhotoItem here, path is', path)
  return (
    <div
      className="photo-item-container"
      onClick={() => onClick()}
      
      style={{
        background: 'white',
        width: size-4,
        height: size,
        border: 'solid thin #CCC',

      }}
      >
        <img src={path} alt="Foto"
          onLoadStart={() => setLoaded(false)}
          onLoad={() => setLoaded(true)}
          style={{
            // width: 'auto',
            objectFit: 'scale-down',
            
            marginLeft: 1, marginRight: 1,
            visibility: loaded ? 'visible' : 'hidden',
            height: size-10,
            width: size - 10,
            maxHeight: size-10,
            position: loaded ? 'relative' : 'absolute',
            maxWidth: size-10,
            borderRadius: '4px',
          }}
        />
        {(!loaded) && (
        <div
          className="photo-item-spinner"
        //  style={{
        //     // width: 'auto',
        //     position: 'absolute',
        //     height: size,
        //     // top: 25,
        //     maxHeight: size,
        //     flex: 1,
        //     maxWidth: size,
        //     borderRadius: '4px',
        //     display: 'flex',
        //     flexDirection: 'column',
        //     alignItems: 'center',
        //     justifyContent: 'flex-start',
        //     // visibility: loaded ? 'hidden' : 'visible'
        // }}
        >
          <CircularProgress style={{color: '#F4868D', transform: 'scale(0.5)'}} />
        </div>
        )}

      </div>
  )
}

export default PhotoItem
